import {makeAutoObservable} from "mobx";
import {AccessService} from "../service/access.service";
import {HelperService} from "../service/helper.service";
import {AppStore} from "./app.store";

export class AccessStore {
    constructor(
        public readonly appStore: AppStore,
        public readonly service: AccessService
    ) {
        makeAutoObservable(this);
    }

    public checkAccesses = async (request: any) => {
        return await this.service.checkAccesses({ ...request })
            .then(({data}) => {
                return data.accessChecks
            });
    }

    public hasAccess = async (request: { routeName: string, attributes: Array<{ [key: string]: [value: any] }> }) => {
        request.routeName = HelperService.generateRoute(request.routeName);

        const { data: { accessChecks } } = await this.service.checkAccesses({ accessChecks: [request] })

        return new Promise((resolve, reject) => {
            let access = accessChecks[0];
            if (access?.allowed && access.allowed) {
                resolve(true);
            } else {
                reject(false);
            }
        })
    }

    public hasFoAccess = ( ) :boolean => {
        return !!this.appStore.authStore.account?.activeRole?.foRole;
    }
}